import React, { useState, useEffect } from 'react';
import './CartItem.css';

function CartItem({ title, src, price, quantity, removeFromCart, updateQuantity, index }) {
  const [localQuantity, setLocalQuantity] = useState(quantity);

  // Update localQuantity when quantity prop changes
  useEffect(() => {
    setLocalQuantity(quantity);
  }, [quantity]);

  const decreaseQuantity = () => {
    if (localQuantity > 1) {
      setLocalQuantity(localQuantity - 1);
      updateQuantity(index, localQuantity - 1);
    } else {
      removeFromCart(index);
    }
  };

  const increaseQuantity = () => {
    setLocalQuantity(localQuantity + 1);
    updateQuantity(index, localQuantity + 1);
  };

  return (
    <div className='cart-item'>
      <div className='cart-image'>
        <img src={src} alt={title} className='fluid-image' />
      </div>
      <div className='cart-details'>
        <div className='cart-heading-price'>
          <p className='cart-para'>{title}</p>
          <p className='cart-price-para'>Price: <span>${price}</span></p>
        </div>
        <div className='counter-part'>
          <p className='quantity-text'>Quantity</p>
          <div className='cart-item-counter'>
            <a onClick={decreaseQuantity}><i className="fa-solid fa-minus"></i></a>
            <div className='counter-para-div'>
              <p className='counter-para'>{localQuantity}</p>
            </div>
            <a onClick={increaseQuantity}><i className="fa-solid fa-plus"></i></a>
          </div>
        </div>
      </div>
      <hr />
    </div>
  );
}

export default CartItem;
